import { createContext, useContext, useReducer, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const initialSpyData = {
  topicsWithSenders: new Set(),
  topicsWithHandlers: new Set()
};
function spyReducer(state, action) {
  switch (action.type) {
    case 'REGISTER_SENDER':
      if (state.topicsWithSenders.has(action.topic)) {
        return state;
      }
      return Object.assign({}, state, {
        topicsWithSenders: new Set([...state.topicsWithSenders, action.topic])
      });
    case 'REGISTER_HANDLER':
      if (state.topicsWithHandlers.has(action.topic)) {
        return state;
      }
      return Object.assign({}, state, {
        topicsWithHandlers: new Set([...state.topicsWithHandlers, action.topic])
      });
    case 'RESET':
      return initialSpyData;
    default:
      return state;
  }
}
const MessageBusSpyContext = /*#__PURE__*/createContext(null);
export const MessageBusSpy = ({
  children
}) => {
  const [spyData, dispatch] = useReducer(spyReducer, initialSpyData);

  // Use stable references to avoid infinite re-renders
  const contextValue = useMemo(() => ({
    spyData,
    registerSender: topic => dispatch({
      type: 'REGISTER_SENDER',
      topic
    }),
    registerHandler: topic => dispatch({
      type: 'REGISTER_HANDLER',
      topic
    }),
    reset: () => dispatch({
      type: 'RESET'
    })
  }), [spyData]);
  return /*#__PURE__*/_jsx(MessageBusSpyContext.Provider, {
    value: contextValue,
    children: children
  });
};
export const useMessageBusSpyContext = () => {
  return useContext(MessageBusSpyContext);
};
export const useMessageBusSpyData = () => {
  const context = useContext(MessageBusSpyContext);
  if (!context) {
    throw new Error('useMessageBusSpyData must be used within a MessageBusSpy component');
  }
  return context.spyData;
};
export const useRegisterSender = () => {
  const context = useMessageBusSpyContext();
  return context === null || context === void 0 ? void 0 : context.registerSender;
};
export const useRegisterHandler = () => {
  const context = useMessageBusSpyContext();
  return context === null || context === void 0 ? void 0 : context.registerHandler;
};
export const useResetMessageBusSpy = () => {
  const context = useMessageBusSpyContext();
  return context === null || context === void 0 ? void 0 : context.reset;
};